module.exports = __webpack_public_path__ + "img/logo.881a12d4.png";